import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { SourceType } from '@/module/Author/Publication/model/PublicationTypes';

import { TitleCard } from '@/core/components';

import { Source } from '@/feature/utils';

import { EditorialTeam } from '../../model/EditorialTeamTypes';
import classes from './EditorialTeamCard.module.css';

export interface EditorialTeamCardProps {
  editorialTeam: EditorialTeam;
  to?: string;
  onClick?: () => void;
}

export function EditorialTeamCard({ editorialTeam, to, onClick }: EditorialTeamCardProps) {
  const { type, startYear, endYear, journalName, publisherName, journalReputation, publisherReputation } =
    editorialTeam;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard
          title={type === 'JOURNAL' ? journalName : publisherName}
          pre={
            <Group gap="3px">
              <Source source={{ type: type as SourceType }} />
            </Group>
          }
        />
        <Group>
          <Pill>{type === 'JOURNAL' ? journalReputation : publisherReputation}</Pill>

          <Text
            c="dimmed"
            size="xs"
          >
            {startYear} - {endYear}
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
